import { ZodObject, ZodRawShape } from "zod";
import { SharedEnvironmentSchema } from "./env.schema";

export const parseEnv = <
  T extends ZodObject<ZodRawShape> = typeof SharedEnvironmentSchema,
>(
  schema: T,
  ease = process.env["EASE_ZOD"] === "true", // EASE ZOD ALLOWS LAMBDA FUNCTIONS TO IGNORE ENVIRONMENT VARIABLE ERRORS (AS NOT ALL OF THEM ARE SET!)
) => {
  const parsedEnv = schema.safeParse({
    ...process.env,
    NODE_ENV: process.env["NODE_ENV"], // Direct reference so frontend webpack can inject it properly
  });

  if (!parsedEnv.success) {
    if (ease) {
      const filledObject = Object.keys(schema.shape).reduce(
        (acc, key) => {
          acc[key] = process.env[key] ?? ""; // Use existing value or empty string
          return acc;
        },
        {} as Record<string, string>,
      );

      return filledObject as T["_output"];
    }

    throw new Error(
      "Environment variables are missing or incorrectly formatted:\n\n" +
        parsedEnv.error.issues
          .map((i) => `  ${i.path.join(".")}: ${i.message}`)
          .join("\n") +
        "\n\n" +
        (process.env["NODE_ENV"] !== "production"
          ? "You might need to run `pnpm pull-env <deploy-alias>` (i.e. staging). \n\n"
          : ""),
    );
  }

  return parsedEnv.data as T["_output"];
};
